function HcUpdateCrossedOut(opts) {
  const variants = opts.variants;
  const options = opts.options;
  const optionNames = opts.optionNames;
  const selectors = opts.selectors;
  const isHierarchical = opts.hierarchy;
  const customDisabler = typeof opts.onDisable === "function" && opts.onDisable;

  const radioAllSelector = selectors.radioAllElements;
  const radioSelector = selectors.radioElement;
  const swatchSelector = selectors.radioContainer;
  const selectorElement = selectors.selectorElement;
  const anySelectorElement = selectors.anySelectorElement;

  const DEFAULT_RADIO_DISABLER = function (el, shouldDisable) {
    const wrap = el.closest(swatchSelector);
    if (wrap) {
      wrap.classList.toggle("hc-soldout-option", shouldDisable);
    }
  };
  const DEFAULT_SELECT_DISABLER = function (el, shouldDisable) {
    el.style.display = shouldDisable ? "none" : "block";
  };

  const disablerFn = customDisabler || (selectorElement ? DEFAULT_SELECT_DISABLER : DEFAULT_RADIO_DISABLER);

  const getIndex = function (optionName) {
    return options.findIndex(function (op) {
      return String(op).toLowerCase() === String(optionName).toLowerCase();
    });
  };

  function getAbsoluteAvailableOptions(optionsArr) {
    const req_index = optionsArr.findIndex(function (opt) {
      return opt === "$x";
    });
    if (req_index < 0) {
      throw new TypeError("$x must be passed to the options array");
    }
    return variants
      .filter(function (variant) {
        if (!variant.available) return false;
        for (const [index, opt] of variant.options.entries()) {
          const constraint = optionsArr[index];
          if (index === req_index) continue;
          if (constraint !== "$all" && constraint !== opt) return false;
        }
        return true;
      })
      .map(function (variant) {
        return variant.options[req_index];
      });
  }

  function getAvailableOptions(optionsArr, requestedOptionName) {
    if (isHierarchical) {
      const req_index = optionsArr.findIndex(function (opt) {
        return opt === "$x";
      });
      const reversedOrder = [].concat(optionNames).reverse();
      for (const optionRev of reversedOrder) {
        if (optionRev === requestedOptionName) break;
        const idx = getIndex(optionRev);
        if (idx >= 0 && idx !== req_index) {
          optionsArr[idx] = "$all";
        }
      }
      return getAbsoluteAvailableOptions(optionsArr);
    } else {
      return getAbsoluteAvailableOptions(optionsArr);
    }
  }

  function getAbsolutePossibleOptions(optionsArr) {
    const req_index = optionsArr.findIndex(function (opt) {
      return opt === "$x";
    });
    if (req_index < 0) {
      throw new TypeError("$x must be passed to the options array");
    }
    return variants
      .filter(function (variant) {
        for (const [index, opt] of variant.options.entries()) {
          const constraint = optionsArr[index];
          if (index === req_index) continue;
          if (constraint !== "$all" && constraint !== opt) return false;
        }
        return true;
      })
      .map(function (variant) {
        return variant.options[req_index];
      });
  }

  function getPossibleOptions(optionsArr, requestedOptionName) {
    if (isHierarchical) {
      const req_index = optionsArr.findIndex(function (opt) {
        return opt === "$x";
      });
      const reversedOrder = [].concat(optionNames).reverse();
      for (const optionRev of reversedOrder) {
        if (optionRev === requestedOptionName) break;
        const idx = getIndex(optionRev);
        if (idx >= 0 && idx !== req_index) {
          optionsArr[idx] = "$all";
        }
      }
      return getAbsolutePossibleOptions(optionsArr);
    } else {
      return getAbsolutePossibleOptions(optionsArr);
    }
  }

  const getSelectedOptions = function () {
    return options.map(function (_name, index) {
      let el;
      if (selectorElement) {
        const sel = selectorElement(index);
        el = document.querySelector(sel);
      } else {
        const base = radioSelector(index);
        el = document.querySelector(base + ":checked");
        if (!el) {
          const all = document.querySelectorAll(base);
          if (all && all.length) {
            el =
              Array.prototype.slice.call(all).find(function (input) {
                return !input.disabled;
              }) || all[0];
          }
        }
      }
      return el && typeof el.value !== "undefined" ? el.value : "";
    });
  };

  function shouldSoldoutUpdate(_optionIndex, optionSelector, newlyPickedSwatchElement) {
    if (!newlyPickedSwatchElement) return true;
    const isSame = newlyPickedSwatchElement.querySelector(optionSelector);
    return !isSame;
  }

  function fireUpdateEvent(optionIndex, optionSelector, availableOptions) {
    const e = new CustomEvent("hc-soldout:update", {
      detail: {
        optionIndex: optionIndex,
        optionSelector: optionSelector,
        availableOptions: availableOptions,
        optionName: String(options[optionIndex]).toLowerCase()
      }
    });
    document.dispatchEvent(e);
  }

  function updateOptions(selectedOptions, changedOption) {
    const optionSelectors = optionNames.map(function (optionName) {
      const optIndex = getIndex(optionName);
      return [optIndex, selectorElement ? selectorElement(optIndex) : radioSelector(optIndex), optionName];
    });

    for (const triple of optionSelectors) {
      const requestedOptionIndex = triple[0];
      const optionSelector = triple[1];
      const requestedOptionName = triple[2];
      if (requestedOptionIndex < 0) continue;
      if (!shouldSoldoutUpdate(requestedOptionIndex, optionSelector, changedOption)) continue;

      const baseArr = selectedOptions.slice();
      const altArr = selectedOptions.slice();
      baseArr[requestedOptionIndex] = "$x";
      altArr[requestedOptionIndex] = "$x";

      const availableValues = getAvailableOptions(baseArr, requestedOptionName);
      const possibleValues = getPossibleOptions(altArr, requestedOptionName);

      let nodes;
      if (selectorElement) {
        const cont = document.querySelector(optionSelector);
        if (!cont) continue;
        nodes = cont.querySelectorAll("[value]");
      } else {
        nodes = document.querySelectorAll(optionSelector);
      }
      if (!nodes || !nodes.length) continue;

      nodes.forEach(function (el) {
        const val = el.getAttribute("value");
        const isAvailable = availableValues.indexOf(val) !== -1;
        const isPossible = possibleValues.indexOf(val) !== -1;
        disablerFn(el, !isAvailable, !isPossible);
      });

      fireUpdateEvent(requestedOptionIndex, optionSelector, availableValues);
    }
  }

  function onLoad() {
    const firstSel = selectorElement ? selectorElement(0) : radioSelector(0);
    if (!firstSel || !document.querySelector(firstSel)) return;
    const selected = getSelectedOptions();
    updateOptions(selected);
    document.body.addEventListener("change", function (e) {
      if (e.hcIgnore) return;
      const inRadios = radioAllSelector && e.target.closest(radioAllSelector);
      const inAny = anySelectorElement && e.target.closest(anySelectorElement);
      if (!inRadios && !inAny) return;
      const selectedOptions = getSelectedOptions();
      const wrap = swatchSelector ? e.target.closest(swatchSelector) : null;
      updateOptions(selectedOptions, wrap);
    });
  }

  onLoad();
}